import { render, staticRenderFns } from "./fileUpload.vue?vue&type=template&id=5207f891&scoped=true"
import script from "./fileUpload.vue?vue&type=script&lang=js"
export * from "./fileUpload.vue?vue&type=script&lang=js"
import style0 from "./fileUpload.vue?vue&type=style&index=0&id=5207f891&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5207f891",
  null
  
)

export default component.exports